import { useTheme, useMediaQuery } from "@mui/material";
const useBreakpoint = (bp) => {
  const theme = useTheme(), only = useMediaQuery(theme.breakpoints.only(bp)), isBp = useMediaQuery(theme.breakpoints.up(bp));
  return {
    [bp]: isBp,
    [`${bp}Only`]: only
  };
};
export {
  useBreakpoint
};
//# sourceMappingURL=useBreakpoint.js.map
